import classnames from "classnames";

import {TooltipWrapper} from "@/components/overlay/TooltipWrapper.tsx";
import {Plan} from "@/lib/types/billing.ts";

import css from "./PlanRow.module.css";

export interface PlanRowStrategyProps {
  plan: Plan;
}

export const PlanRowStrategy = ({plan}: PlanRowStrategyProps) => {
  return (
    <TooltipWrapper toolTip="Setup a Free Strategy Session with our monitoring experts on how best to monitor your sites and services! Additional services available for a small cost.">
      <div className={css.PlanRowHeader}>
        <h2 className={classnames(css.PlanRowHeader, "w-100 text-center fw-semibold fs-5")}>
          {plan === Plan.Starter ? "30 Mins" : "1 Hour"} {plan === Plan.Custom && "+"}
        </h2>
        <div className="w-100 text-center px-3">
          <small className="d-block lh-sm fw-light">
            Free {plan === Plan.Starter ? "30-min" : "1-hour"} Strategy Session <br />
            Additional Sessions Available
          </small>
        </div>
      </div>
    </TooltipWrapper>
  );
};
